/** Ambient classified-UI overlay: faint coordinate rails + encrypted fragments. */
export const EncryptedOverlay = () => {
  return (
    <div
      data-testid="encrypted-overlay"
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[1] hidden lg:block"
    >
      <div className="absolute left-6 top-1/2 flex -translate-y-1/2 flex-col gap-7 font-mono-accent text-[9px] uppercase tracking-[0.25em] text-white/[0.12]">
        <span>01N</span>
        <span>02N</span>
        <span>03N</span>
        <span>04N</span>
        <span>05N</span>
      </div>
    </div>
  );
};
